import { render } from "./UpdateTask.vue?vue&type=template&id=283fcea9"
import script from "./UpdateTask.vue?vue&type=script&lang=js"
export * from "./UpdateTask.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__